export default __webpack_public_path__ + "static/Canva-7c37ce0c15af5bf7e2f466a6682a4aee.svg";